<div class="table-wrapper">
  <div class="table-scroll">
    @if (headers().length > 0) {
      <table class="data-table">
        <thead>
          <tr>
            @for (header of headers(); track header.value) {
              <th>{{ header.description }}</th>
            }
          </tr>
        </thead>
        <tbody>
          @if (isLoading()) {
            <tr>
              <td [attr.colspan]="headers().length">
                <app-load-skeleton [rows]="5" [columns]="headers().length" />
              </td>
            </tr>
          } @else {
            @for (row of dataSource().data; track row.id) {
              <tr>
                @for (header of headers(); track header.value; let indexColum = $index) {
                  <td>
                    @if (indexColum === 0) {
                      @if (buttonEvent() && !checkEvent() && !hasExpansion()) {
                        <button
                          class="action-btn action-btn--primary"
                          [matTooltip]="'common.actions.view' | translate"
                          (click)="emitterButton(row[header.value], row)"
                        >
                          <mat-icon>visibility</mat-icon>
                        </button>
                      } @else if (!buttonEvent() && checkEvent() && !hasExpansion()) {
                        <mat-checkbox (change)="updateElement(row, header.value, $event.checked)" />
                      } @else if (hasExpansion() && !buttonEvent() && !checkEvent()) {
                        <button
                          class="action-btn action-btn--primary"
                          [matTooltip]="'common.actions.expand' | translate"
                          (click)="emitterButton(row[header.value], row)"
                        >
                          <mat-icon>{{ row.isExpanded ? 'expand_less' : 'expand_more' }}</mat-icon>
                        </button>
                      } @else {
                        {{ row[header.value] ?? '-' }}
                      }
                    } @else if (indexColum === headers().length - 1 && menuButton().length > 0) {
                      <div class="action-buttons">
                        @for (button of menuButton(); track button.key) {
                          <button
                            class="action-btn"
                            [ngClass]="getActionColorClass(button.key)"
                            [matTooltip]="button.toolTip || button.text"
                            (click)="endEmitter(button.key, row)"
                          >
                            <mat-icon>{{ button.icon }}</mat-icon>
                          </button>
                        }
                      </div>
                    } @else {
                      @if (isBoolean(row[header.value])) {
                        <span [class.boolean-yes]="row[header.value]" [class.boolean-no]="!row[header.value]">
                          {{ row[header.value] ? ('common.yes' | translate) : ('common.no' | translate) }}
                        </span>
                      } @else if (header.value.includes('$') || header.description.includes('$')) {
                        <span class="cell-badge">
                          {{ row[header.value] | currency: 'USD' : 'symbol' : '1.2-2' }}
                        </span>
                      } @else if (header.value.includes('%')) {
                        {{ row[header.value] / 100 | percent: '1.2-2' }}
                      } @else {
                        @if (hasHighlight(row[header.value])) {
                          <span class="cell-badge" [ngStyle]="getCellStyle(header.value, row[header.value])">
                            {{ row[header.value] ?? '-' }}
                          </span>
                        } @else {
                          {{ row[header.value] ?? '-' }}
                        }
                      }
                    }
                  </td>
                }
              </tr>
            } @empty {
              <tr>
                <td [attr.colspan]="headers().length" class="empty-state">
                  {{ 'common.noData' | translate }}
                </td>
              </tr>
            }
          }
        </tbody>
      </table>
    } @else {
      <div class="empty-state">{{ 'common.noData' | translate }}</div>
    }
  </div>
</div>
